var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout__row",staticStyle:{"padding-left":"30px","padding-right":"30px","padding-bottom":"30px"},attrs:{"id":"application-create"}},[_c('div',{staticClass:"row",class:{'w-100':!_vm.officeId}},[_c('div',{class:{'w-50':_vm.officeId && _vm.typeId == _vm.APP_TYPE_DEMO ,'col-md-5':_vm.officeId && _vm.typeId != _vm.APP_TYPE_DEMO ,'col-md-6':!_vm.officeId}},[_c('div',{staticClass:"section"},[_c('ApplicationCreateComponent')],1)]),(_vm.officeId && _vm.typeId != _vm.APP_TYPE_DEMO)?_c('div',{staticClass:"col-md-7 mr-0"},[_c('CalendarComponent',{attrs:{"subject-id":_vm.officeId ? _vm.officeId : null,"subject-type":_vm.officeId ? 'office' : 'all',"filter-params":{filter:'future'},"calendar-options":{
                            defaultView: 'dayGridMonth',
                            header: {
                                left: 'prevYear,prev,next,nextYear, today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay'
                            },
                            businessHours:false,
                            eventCreate:false,
                            calendarWeekends: true,
                            tableView: false,
                            allDayDefault: false,
                            editable: false,
                            eventOverlap: true,
                            displayEventEnd: true,
                            droppable: false,
                            windowResizeDelay: 100,
                            eventBackgroundColor:'#d7f0f7'
                         },"active":!!_vm.officeId}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }